/* jshint esversion: 6 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Loading from 'app/components/common/Loading.jsx';

const HashtagGenerator = (props) => {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ guid, setGuid ] = useState('');
    const [ error, setError ] = useState(null);
    const [ hashtags, setHashtags ] = useState([]);
    const [ selectedTags, setSelectedTags ] = useState([]);
    const [ lastPrompt, setLastPrompt ] = useState({
        message: '',
        link: ''
    });

    // try and load up the first set when the component is mounted
    useEffect(() => {
        getHashtags();
    }, [])


    const getHashtags = () => {
        if (props.postData.message === '' && props.postData.link === '') {
            setError("We'll need some text or a link before we can generate smart hashtags for you.");
            return;
        }

        let nextLastPrompt = {
            message: '',
            link: ''
        };

        nextLastPrompt.message = props.postData.message;
        nextLastPrompt.link = props.postData.link;

        setLastPrompt(nextLastPrompt);
        setIsLoading(true);
        setError('');

        axios({
            url: `${props.app.config.apiUrl}/post/aiHashtags`,
            data: {
                content: nextLastPrompt.message,
                link: nextLastPrompt.link
            },
            headers: { "Content-type": "application/json" },
            method: 'POST',
            withCredentials: true,
            responseType: 'json'
        }).then((response) => {
            setIsLoading(false);
            if (response.data !== undefined) {
                if (response.data.hashTags.length === 0) {
                    setError("We couldn't generate any smart hashtags for your text. Try modifying your text and requesting a new set.");
                }
                setHashtags(response.data.hashTags);
                setSelectedTags([]);
                if (response.data.guid) {
                    setGuid(response.data.guid);
                }
            }
        }).catch((error) => {
            // axios keeps the server's answer on the error's response
            let errors = (error.response && error.response.data) ? error.response.data.errors : undefined;

            if (errors !== undefined && errors.hashtags !== undefined) {
                setError(errors.hashtags);
            } else {
                setError("There was an error creating hashtags. Try again shortly.");
            }

            setIsLoading(false);
        });

    }

    const selectHashtag = (e) => {
        let tag = e.target.dataset.tag,
            action = 'add',
            nextSelectedTags = [...selectedTags];

        if (tag) {
            if (selectedTags.indexOf(tag) !== -1) {
                action = 'remove';
                nextSelectedTags.splice(selectedTags.indexOf(tag), 1);
            } else {
                nextSelectedTags.push(tag)
            }
            setSelectedTags(nextSelectedTags);
            props.onHashtagSelect(tag, action, props.service);

            // report usage
            // one way trip, don't care about errors or returns
            if (guid) {
                axios({
                    url: `${props.app.config.apiUrl}/post/aiHashtagsUse`,
                    data: {
                        guid,
                        tag,
                        add: (action === 'add') ? 1 : 0
                    },
                    headers: { "Content-type": "application/json" },
                    method: 'POST',
                    withCredentials: true,
                    responseType: 'json'
                });
            }

        }
    };

    let errorDisplay = null,
        hashtagContent = null;

    if (error) {
        errorDisplay = (
            <ul className="pt-service-info">
                <li className="post-info">
                    {error}
                </li>
            </ul>
        );
    }

    hashtagContent = (
        <div className="hashtag-response">
            <div className="hashtag-header">Smart Hashtags:</div>
            {isLoading === false ? (
                <div className="hashtag-refresh" role="button" aria-label="Refresh smart hashtags" onClick={getHashtags}>
                    <i className="icon ion-refresh"/>
                </div>
            ) : null}
            {isLoading ? (
                <div className="hashtag-loader">
                    <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>
                </div>
            ) : (
                <ul className="post-hashtag-list">
                {hashtags.map((hashtag, i) => {
                    let hashtagClass = 'post-hashtag';

                    if (selectedTags.indexOf(hashtag) !== -1) {
                        hashtagClass += ' active';
                    }

                    return (
                        <li key={`tag-${i}`} className={hashtagClass} role="button" aria-pressed={selectedTags.indexOf(hashtag) !== -1} onClick={selectHashtag} data-tag={hashtag}>
                            {hashtag}
                        </li>
                    );
                })}
            </ul>
            )}
        </div>
    );


    return (
        <div className="post-tool-hashtags">
            {errorDisplay}
            {hashtagContent}
        </div>
    )
};

export default HashtagGenerator;
